export default __webpack_public_path__ + "static/media/add-to-playlist-green.806fdaa0.svg";